import { createTelemetry, createTelemetryObject } from '@shared/core/analytics/telemetry';
import { ThingToDoComponentProps } from './ThingToDoComponent';

export type LayoutType = 'clean' | 'modal' | 'links' | 'sidebar' | '';

interface ThingsToDoInfo {
  componentName: string;
  url: string;
  thingToDoName: string;
  city?: string;
  tours?: ThingToDoComponentProps['tours'];
  version?: 'v1' | 'v2';
}

const prefixes = {
  category: 'custom',
  pagePrefix: 'guest',
};

export const thingsToDoTelemetry = createTelemetryObject({
  pages: {
    thingsToDoLayoutsExperiment: () => ({
      pagePrefix: 'guest',
      page: 'thingsToDoModal',
      category: 'custom',
    }),
  },
  actions: {
    abTestAssignmentThingsToDoLayout: (assignment: LayoutType) => ({
      pagePrefix: 'guest',
      category: 'custom',
      action: 'ABTestAssigned',
      extraInfo: {
        name: 'thingsToDoLayoutsExperiment',
        value: assignment ? assignment : 'off',
      },
    }),
    thingsToDoCTAClicked: (page: string, args: ThingsToDoInfo) => ({
      ...prefixes,
      page,
      action: 'ButtonInteracted',
      label: 'See more tickets & tours',
      extraInfo: {
        ...args,
      },
    }),
    thingsToDoTourClicked: (page: string, args: ThingsToDoInfo) => ({
      ...prefixes,
      page,
      action: 'ButtonInteracted',
      label: 'See Tour',
      extraInfo: {
        ...args,
      },
    }),
  },
});

const { TelemetryProvider, useTelemetry } = createTelemetry(thingsToDoTelemetry, { eventId: '' });

export { TelemetryProvider, useTelemetry as useThingsToDoTelemetry };
